import store from '../../../store';

export const checkTimeDifference = () => {
  const state = store.getState();
  const currentTime = state.auth && state.auth.user ? new Date(state.auth.user.currentTime) : new Date();
  const now = new Date();
  const timeDifference = Math.abs(now - currentTime) / 1000 / 60;
  
  if (timeDifference > 3) {
    // console.log('greater than 3 minutes. ' + timeDifference);
    return true
  } else {
    // console.log('within the 3-minute tolerance. ' + timeDifference);
    return false
  }
};
